import { useParams } from "react-router-dom";
import {useGetVideosQuery} from "../../features/videos/videosApi";
import CourseVideos from "../../components/student/videos/CourseVideos";
import ActiveVideo from "../../components/student/videos/ActiveVideo";
import EmptyResult from "../../components/ui/EmptyResult";
import Loading from "../../components/ui/Loading";
import Error from "../../components/ui/Error";

export default function CoursePlayer() {
	const {
		data: videos,
		isLoading,
		isError
	} = useGetVideosQuery() || {};
	let { videoId } = useParams();

	// Decide what to render
	let content = null;
	if (isLoading) {
		content = <Loading />;
	} else if (!isLoading && isError) {
		content = <Error message="There was an error!" />;
	} else if (!isLoading && !isError && videos?.length === 0) {
		content = <EmptyResult contentName="videos" />;
	} else if (!isLoading && !isError && videos?.length > 0) {
		if (videoId === undefined) {
			videoId = videos[0].id;
		}

		content = (
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-7xl px-5 lg:px-0">
					<div className="grid grid-cols-3 gap-2 lg:gap-8">
						<ActiveVideo videoId={videoId} />
						<CourseVideos videos={videos} />
					</div>
				</div>
			</section>
		);
	}

	return (
		<>
			{content}
		</>
	);
}
